import { createFileRoute, Outlet } from '@tanstack/react-router'
import StaffOnly from "@/user/StaffOnly";

export const Route = createFileRoute('/_authenticated/_staff')({
  component: RouteComponent,
})

function RouteComponent() {
  return <StaffOnly><Outlet/></StaffOnly>
}
